import { useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/ui/sidebar";
import { Lock, User, ChevronRight, Settings } from "lucide-react";

const options = [
  {
    label: "Cambiar contraseña",
    description: "Actualiza tu contraseña de acceso al sistema",
    icon: <Lock size={28} className="text-military-600" />,
    path: "/ChangePasswordPage",
    color: "border-military-500",
    bg: "bg-military-50",
  },
  {
    label: "Perfil de usuario",
    description: "Edita tu nombre, documento, celular y foto de perfil",
    icon: <User size={28} className="text-blue-600" />,
    path: "/UserProfilePage",
    color: "border-blue-500",
    bg: "bg-blue-50",
  },
];

export default function ConfigurarSistemaPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 text-gray-900">
      <Sidebar />
      <main className="flex-1 p-4 sm:p-6 md:ml-64 transition-all">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-1">
            <Settings size={28} className="text-military-600" />
            <h1 className="text-2xl sm:text-3xl font-bold text-military-600">
              Configurar Sistema
            </h1>
          </div>
          <p className="text-gray-500 text-sm ml-1">
            Administra tus datos personales y seguridad de acceso
          </p>
        </div>

        {/* Opciones */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
          {options.map((opt) => (
            <button
              key={opt.path}
              onClick={() => navigate(opt.path)}
              className={`flex items-center gap-4 p-5 bg-white rounded-2xl border-l-4 ${opt.color} shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all text-left w-full`}
            >
              <div className={`p-3 rounded-full ${opt.bg} flex-shrink-0`}>
                {opt.icon}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900 text-base">{opt.label}</p>
                <p className="text-sm text-gray-500 mt-0.5 leading-snug">
                  {opt.description}
                </p>
              </div>
              <ChevronRight size={20} className="text-gray-400 flex-shrink-0" />
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
